import { useMemo } from "react";
import { Flex, Tabs, Typography } from "antd";
import { useCan, useTranslate } from "@refinedev/core";
import { useSession } from "hooks/useSession";
import { PreferencesTab } from "./components/PreferencesTab";
import { DataExportTab } from "./components/DataExportTab";
import { IntegrationsTab } from "./components/IntegrationsTab";
import { GroupMappingsTab } from "./components/GroupMappingsTab";
import { selectUserCan } from "helpers/utils";
const { Title, Text } = Typography;

export const OrganizationPreferencesPage = () => {
  const t = useTranslate();
  const { currentOrganization, accesses } = useSession();
  const { data: canEditOrg } = useCan({
    resource: "organization",
    action: "edit",
  });
  // Group mappings only exist for orgs linked to an SSO (Scalekit) organization
  const canSeeGroupMappings =
    Boolean(currentOrganization?.sso_organization_id) &&
    Boolean(
      selectUserCan(accesses, {
        subject: "Organization.ScimGroupMapping",
        action: "read",
        scope: "ORG",
      })
    );

  const items = useMemo(() => {
    const tabs = [
      {
        key: "preferences",
        label: t("media.organizations.tabs.preferences"),
        children: <PreferencesTab />,
      },
    ];
    if (canEditOrg?.can) {
      tabs.push(
        {
          key: "data-export",
          label: t("media.organizations.tabs.dataExport"),
          children: <DataExportTab />,
        },
        {
          key: "integrations",
          label: t("media.organizations.tabs.integrations"),
          children: <IntegrationsTab />,
        }
      );
    }
    if (canSeeGroupMappings) {
      tabs.push({
        key: "group-mappings",
        label: t("media.organizations.tabs.groupMappings"),
        children: <GroupMappingsTab />,
      });
    }
    return tabs;
  }, [canEditOrg?.can, canSeeGroupMappings, t]);

  return (
    <Flex vertical gap="large" style={{ width: "100%" }}>
      <Title level={2} style={{ marginBottom: 0 }}>
        {t("media.organizations.index.organizationSettings")}
      </Title>
      {currentOrganization?.id && (
        <Text type="secondary" copyable={{ text: currentOrganization.id }}>
          {t("media.organizations.index.organizationId")}:{" "}
          {currentOrganization.id}
        </Text>
      )}
      <Tabs items={items} />
    </Flex>
  );
};

export default OrganizationPreferencesPage;
